// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__CPql5","container":"About_container__qisZI","left":"About_left__al9cJ","right":"About_right__VDMXJ"};